import { auth } from '@/firebase/firebaseServices.js';
import { signInWithEmailAndPassword } from 'firebase/auth';

class AuthService {
    public async loginWithEmailAndPassword(email: string, password: string) {
        const userCredentials = await signInWithEmailAndPassword(auth, email, password);
        return userCredentials.user;
    }

    public async logout() {
        await auth.signOut();
    }
}

export default function useAuthService() {
    return new AuthService();
}
